// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionRecordUpdateRequestDto
 */
export interface IContributionRecordUpdateRequestDto {
    /**
     * Existing contribution record identifier
     * @type {number}
     * @memberof IContributionRecordUpdateRequestDto
     */
    record_id: number;
    /**
     * New employee (EE) contribution amount for the record
     * @type {number}
     * @memberof IContributionRecordUpdateRequestDto
     */
    ee_amount?: number;
    /**
     * New employer (ER) contribution amount for the record
     * @type {number}
     * @memberof IContributionRecordUpdateRequestDto
     */
    er_amount?: number;
    /**
     * New contribution date
     * @type {Date}
     * @memberof IContributionRecordUpdateRequestDto
     */
    date: Date;
    /**
     * New tax year
     * @type {string}
     * @memberof IContributionRecordUpdateRequestDto
     */
    tax_year: string;
    /**
     * New tax type
     * @type {string}
     * @memberof IContributionRecordUpdateRequestDto
     */
    tax_type: IContributionRecordUpdateRequestDtoTaxTypeEnum;
    /**
     * Optional memo for the record
     * @type {string}
     * @memberof IContributionRecordUpdateRequestDto
     */
    memo?: string | null;
    /**
     * Flag to mark record as disabled
     * @type {boolean}
     * @memberof IContributionRecordUpdateRequestDto
     */
    disabled?: boolean | null;
}

/**
* @export
* @enum {string}
*/
export enum IContributionRecordUpdateRequestDtoTaxTypeEnum {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX'
}


/**
 * Check if a given object implements the IContributionRecordUpdateRequestDto interface.
 */
export function instanceOfIContributionRecordUpdateRequestDto(value: object): value is IContributionRecordUpdateRequestDto {
    if (!('record_id' in value) || value['record_id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('tax_year' in value) || value['tax_year'] === undefined) return false;
    if (!('tax_type' in value) || value['tax_type'] === undefined) return false;
    return true;
}

export function IContributionRecordUpdateRequestDtoFromJSON(json: any): IContributionRecordUpdateRequestDto {
    return IContributionRecordUpdateRequestDtoFromJSONTyped(json, false);
}

export function IContributionRecordUpdateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionRecordUpdateRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'record_id': json['record_id'],
        'ee_amount': json['ee_amount'] == null ? undefined : json['ee_amount'],
        'er_amount': json['er_amount'] == null ? undefined : json['er_amount'],
        'date': (new Date(json['date'])),
        'tax_year': json['tax_year'],
        'tax_type': json['tax_type'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
    };
}

export function IContributionRecordUpdateRequestDtoToJSON(json: any): IContributionRecordUpdateRequestDto {
    return IContributionRecordUpdateRequestDtoToJSONTyped(json, false);
}

export function IContributionRecordUpdateRequestDtoToJSONTyped(value?: IContributionRecordUpdateRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'record_id': value['record_id'],
        'ee_amount': value['ee_amount'],
        'er_amount': value['er_amount'],
        'date': ((value['date']).toISOString().substring(0,10)),
        'tax_year': value['tax_year'],
        'tax_type': value['tax_type'],
        'memo': value['memo'],
        'disabled': value['disabled'],
    };
}

